import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { AtualizacoesAudit } from '../models/atualizacoes-audit';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AtualizacoesAuditService extends BaseService<AtualizacoesAudit> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/projetos/audit';
  }

  public getAtualizacoes(obj: Object = null): Observable<AtualizacoesAudit[]> {
    return this.http.post<AtualizacoesAudit[]>(this.baseUrl + '/atualizacoes', obj, { headers: this.headers });
  }

}